<template>
  <v-app>
    <v-main >
      <v-container fluid fill-height align-start >
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              Lista Subida con Éxito
            </v-card-title>
            <v-card-text>Los emails fueron enviados con éxito!</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <v-dialog v-model="dialogdelete" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Desea eliminar esta Persona de la Lista?</v-card-title>
            <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="close">No</v-btn>
              <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <section v-if="activopr" id="main-cabecera" >
        <v-card> <v-card-title> <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1  class="display-1 font-weight-bold">
              Hola {{promotor.promotorNombre}}
              </h1>
            </v-col>
          </v-row></v-card-title>
          <v-card-text>
          <v-row  justify="space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-form  ref="form">
                <v-row>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="fiestaId" :items="fiestas" item-value="id" item-text="nombre"  persistent-hint

                                     single-line label="Escoger Fiesta"></v-autocomplete>
                  </v-col>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="tipoListaId" :items="tipolistas" @change="dameMaximos"  item-value="tipoLista.id" item-text="tipoLista.tipoListaNombre"  persistent-hint

                                     single-line label="Escoger Tipo Lista"></v-autocomplete>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <p>Cantidad Maxima :  {{cantmax.cantidadmaxima}}</p>
                    <p>Cantidad en Lista Actualmente: {{cantmax.cantidadactual}}</p>
                    <p>Posibles :{{cantmax.posibles}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    Plantilla para subir se necesita Nombre, Apellidos y Email <a href="/files/PLANTILLALISTATUNAY.xlsx" download>Plantilla</a>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="mostrar">
                    <v-file-input v-if="ress" :loading="progr" v-model="file" :show-size="true" @change="subexcel" :type="'file'" accept=".xlsx"></v-file-input>
                  <v-data-table v-else :headers="headers"  :items="filelist">

                  </v-data-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn  :disabled="botn"  @click="save">Enviar QRs</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
         </v-card-text>
        </v-card>
        </section>
        <section v-else>
          <v-row align="center" class="text-center">
            <v-col cols="12" sm="12" md="12" lg="12">
              <h1  class="display-1 font-weight-bold">
                Hola {{promotor.promotorNombre}}, fuiste desactivado como promotor.
              </h1>
            </v-col>
          </v-row>
        </section>
        <leftsinmenupromotor  />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment";
import * as XLSX from "xlsx";
import leftsinmenupromotor from "@/components/general/leftsinmenupromotor";

export default {
  name: "listaemail",
  components: {
    leftsinmenupromotor
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Lista de  "+this.titulonegocio
      }
    ]
    }
  },
  data () {
    return {
      md5promo: '',
      overlay: false,
      alertnuevo: false,
      logoexist: false,
      logoimg: null,
      file: File,
      arrayBuffer: null,
      mostrar:false,
      ress: true,
      filelist: null,
      botn: false,
      cantidad: 0,
      cantmax: {
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual: '',
        posibles: ''
      },
      maximo: 0,
      progr:false,
      mostrarlista:true,
      nombres:'',
      fiestaId:0,
      tipoListaId:0,
      search: '',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Nombre', value: 'NOMBRE' },
        { text: 'Apellido', value: 'APELLIDOPATERNO'},
        { text: 'Email', value: 'EMAIL'},
      ],
      promotor:{},
      fiestas: [],
      dialogdelete: false,
      tipolistas:[],
      activopr:true,
      listas:[],
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  }
  ,
  mounted (){
    this.md5promo =  this.$route.params.md5promo;
    this.damepromotor();
  }
,

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    subexcel(){

      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
        var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.filelist = arraylist;
        this.ress = false;
        console.log(e);
      };
    },
    dameMaximos(){
      let urlfiesta = 'promotores/maximos';
      var bodyFormData = new FormData();
      let fiest = this.fiestas.find(x=>x.id ===this.fiestaId)
      let fechamax = this.formatDateee(fiest.fechaInicio+' '+fiest.horaPromotorCierre)
      let hoy = this.formatDateee(new Date());
      if   (fechamax <= hoy ){
        this.botn = true
      }else{
        this.botn = false
      }
      bodyFormData.append("personaId",this.promotor.id);

      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      if(this.tipoListaId>0 && this.promotor.id>0 && this.fiestaId>0){
        this.overlay = true
        this.mostrar = true
        axios
            .post(urlfiesta,bodyFormData,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            })
            .then(response => {
              this.cantmax = response.data;
              this.maximo = this.cantmax.posibles
              this.overlay = false;
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });
      }
    },

    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },

    save () {
      this.overlay = true;

      var bodyFormData = new FormData();
      bodyFormData.append("promotorId",this.promotor.id);
      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      bodyFormData.append("data",JSON.stringify(this.filelist));
      axios
          .post('lista/fiesta/qr/email',bodyFormData).then(response => {
        this.listas=response.data
        this.mostrarlista = false
            this.alertnuevo = true;
        this.overlay = false;
        this.$refs.form.reset()
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    },
    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },
    damefiestas(){
      this.progr = true;
      let urlfiesta = 'promotores/fiestas';
      var bodyFormData = new FormData();
      bodyFormData.append("promotorId",this.promotor.id);
      axios
          .post(urlfiesta,bodyFormData)
          .then(response => {
            this.fiestas = response.data;
            this.progr = false;
            this.dametipolistas()
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    damepromotor(){
      this.progr = true;
      axios
          .get('promotores/lista/'+this.md5promo)
          .then(response => {
            this.promotor = response.data;
            console.log("promotor");
            console.log(this.promotor)
            this.editedItem.listaFiesta.promotor = this.promotor
            this.activopr = this.promotor.activo
            this.damefiestas()

          })
          .catch((error)  => {
            console.log(error);
          });
    },

    borralo (){
      this.overlay = true
      axios
          .delete('lista/'+ this.listas[this.editedIndex].codigoUnico)
          .then(response => {
            console.assert(true,response);
            this.dialogdelete = false;
            this.listas=response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });
    },
    dametipolistas(){
      this.progr = true;
      axios
          .get('promotortipolistas/promotor/'+this.promotor.id)
          .then(response => {
            this.tipolistas = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>

</style>